















import Vue from "vue";
import { Trans } from "@/shared/scripts/helpers/translation/translation";

export default Vue.extend({
    name: "TrustpilotWidget",

    computed: {
        currentLanguage: function(): string {
            return Trans.currentLocale;
        },
        dataLocale: function(): string {
            const localeMap: Record<string, string> = {
                en: "en-US",
                fr: "fr-FR",
                nl: "nl-NL",
            };
            return localeMap[this.currentLanguage] || "en-US";
        },
        reviewUrl: function(): string {
            const urlMap: Record<string, string> = {
                en: "https://trustpilot.com/review/www.immoweb.be",
                fr: "https://fr.trustpilot.com/review/www.immoweb.be",
                nl: "https://nl.trustpilot.com/review/www.immoweb.be",
            };
            return urlMap[this.currentLanguage] || "https://trustpilot.com/review/www.immoweb.be";
        }
    },

    mounted: function() {
        if ((window as any).Trustpilot) {
            (window as any).Trustpilot.loadFromElement(this.$el);
        }
    },
});

